enum LoanPayoutFigurePrepaidInterestModeEnum {
    Auto = 'AUTO',
    Manual = 'MANUAL',
}

export default LoanPayoutFigurePrepaidInterestModeEnum;